import React, { useMemo } from "react";

type SparklineProps = {
  data: number[];
  color: string;
  width?: number;
  height?: number;
};

const Sparkline = ({
  data,
  color,
  width = 80,
  height = 28,
}: SparklineProps) => {
  const path = useMemo(() => {
    if (data.length < 2) return "";

    const max = Math.max(...data);
    const min = Math.min(...data);
    const range = max - min || 1;

    const padY = 2;
    const usableHeight = height - padY * 2;

    const points = data.map((value, i) => {
      const x = (i / (data.length - 1)) * width;
      const y = padY + usableHeight - ((value - min) / range) * usableHeight;

      return { x, y };
    });

    return points
      .map((p, i) => (i === 0 ? `M${p.x},${p.y}` : `L${p.x},${p.y}`))
      .join(" ");
  }, [data, width, height]);

  if (data.length < 2) return null;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={{ display: "block" }}
    >
      <path
        d={path}
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d={`${path} L${width},${height} L0,${height} Z`}
        fill={color}
        fillOpacity={0.1}
      />
    </svg>
  );
};

export default React.memo(Sparkline);
